module.exports = __webpack_public_path__ + "media/gallery/photo08-a95b2b58.webp";